import _isNil from "lodash/isNil";
import { AMAZON_CONNNECT_ID } from "../app-consts/appConstants";
import { datadogRum } from "@datadog/browser-rum";

export const injectAmazonConnect = (
  amazonConnect = {},
  afterVaChatLoaded = (data) => {}
) => {
  const url = amazonConnect?.url || "";
  const configId = amazonConnect.configId || "";
  const amazonConnectScriptElement =
    document.getElementById(AMAZON_CONNNECT_ID);
  if (_isNil(amazonConnectScriptElement) && url && configId && !getVaChat()) {
    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.src = url;
    script.id = AMAZON_CONNNECT_ID;
    script.onload = () => {
      const vaChat = getVaChat();
      vaChat.config({
        id: configId,
        hideChatIcon: true,
        company: "NA",
      });
      afterVaChatLoaded({ loaded: true });
    };
    document.body.appendChild(script);
  }
  if (!_isNil(amazonConnectScriptElement) && url && configId && getVaChat()) {
    afterVaChatLoaded({ loaded: true });
  }
};
let attributes;
export const getVaChat = () => {
  if (_isNil(window.vaChat)) {
    return undefined;
  }
  return window.vaChat;
};

export const promiseInjectAmazonConnect = (amazonConnect = {}) => {
  return new Promise((resolve, reject) => {
    const url = amazonConnect?.url || "";
    const configId = amazonConnect.configId || "";
    const amazonConnectScriptElement =
      document.getElementById(AMAZON_CONNNECT_ID);

    // Check if script needs to be injected
    if (_isNil(amazonConnectScriptElement) && url && configId && !getVaChat()) {
      const script = document.createElement("script");
      script.async = true;
      script.defer = true;
      script.src = url;
      script.id = AMAZON_CONNNECT_ID;

      script.onload = () => {
        try {
          const vaChat = getVaChat();
          vaChat.config({
            id: configId,
            hideChatIcon: true,
            company: "NA",
            va_securedformopen: "open",
          });
          resolve(true); // Resolve the promise after the script loads successfully
        } catch (error) {
          reject(error); // Reject in case of any error
        }
      };

      script.onerror = (error) => {
        reject(error); // Reject the promise if script loading fails
      };

      document.body.appendChild(script);
    }

    // If script is already present and vaChat is available, resolve the promise
    if (!_isNil(amazonConnectScriptElement) && url && configId && getVaChat()) {
      resolve(true); // Resolve the promise if no script injection is needed
    }
  });
};

export const getChatbotContactIdFromLocalStorage = () => {
  const session = JSON.parse(
    localStorage.getItem("__VirtualAssistant____ACTIVE_SESSION__")
  );
  const contactId = session && session.ContactId;
  return contactId !== null ? contactId : "";
};

function updateChatAttrEvent() {
  //ADDING LOGGING FOR DEBUGGING, WILL BE REMOVED
  datadogRum.addAction("Updating Chat Attributes", {
    ...attributes,
  });
  getVaChat().updateConnectParameters({
    attributes,
  });
}

export const updateChatbotAttributes = (attr) => {
  attributes = attr;
  const hasActiveChat =
    localStorage.getItem("__VirtualAssistant____IS_ACTIVE__") === '"TRUE"';

  if (hasActiveChat) {
    getVaChat().updateConnectParameters(attr);
  } else {
    document.removeEventListener("onChatClick", updateChatAttrEvent);
    document.addEventListener("onChatClick", updateChatAttrEvent);
  }
};

export const removeChatEventlisteners = () =>
  document.removeEventListener("onChatClick", updateChatAttrEvent);
